import { useLocation } from "react-router-dom";
import InviteForm from "./InviteForm";
import ForgetPassForm from "./ForgetPassForm";
import ResetPassword from "./ResetPassword";

const PassSignIn = () => {
  const location = useLocation();

  let formType = "signup";

  if (location.search.includes("?token=")) {
    formType = "invitation";
  } else if (location.search.includes("?user_token=")) {
    formType = "new_password";
  } else if (location.pathname.includes("/resetpassword")) {
    formType = "reset_password";
  }

  return (
    <>
      {formType === "reset_password" ?
        <ForgetPassForm />
      : formType === "new_password" ?
        <ResetPassword />
      : formType === "invitation" ?
        <InviteForm />
      : null}
    </>
  );
};

export default PassSignIn;
